import { twMerge } from "tailwind-merge";

/**
 * cn — merge Tailwind class strings, deduping conflicting utilities so the last
 * one wins deterministically (e.g. cn("gap-4", "gap-8") → "gap-8"). This avoids
 * relying on compiled-CSS order, which differs between dev and prod under
 * Tailwind's global `important` setting.
 *
 * @param {...(string|false|null|undefined)} inputs - Class strings (falsy skipped)
 * @returns {string}
 */
const cn = (...inputs) => twMerge(inputs.filter(Boolean).join(" "));

export default cn;
